import React from "react"

import { cn } from "@/lib/utils"

/**
 * Einblenden beim Scrollen, rein in CSS (siehe .reveal in src/styles.css).
 * Ersetzt die motion-Variante: kein JavaScript, nur opacity und transform, die der
 * Browser auf dem Compositor animiert. Browser ohne scroll-getriebene Animationen
 * zeigen den Inhalt sofort.
 */
interface BlurFadeProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode
  /** Element, das gerendert wird, z. B. "li" innerhalb einer Liste */
  as?: "div" | "li" | "article" | "section"
  /** Versatz in Sekunden, für gestaffelte Karten */
  delay?: number
  /** Aus der motion-Variante übernommen, ohne Wirkung */
  inView?: boolean
  direction?: "up" | "down"
}

export function BlurFade({
  children,
  className,
  as: Tag = "div",
  delay = 0,
  inView: _inView,
  direction: _direction,
  style,
  ...props
}: BlurFadeProps) {
  return (
    <Tag
      className={cn("reveal", className)}
      style={delay ? ({ "--reveal-shift": `${Math.round(delay * 100)}px`, ...style } as React.CSSProperties) : style}
      data-blur-fade=""
      {...props}
    >
      {children}
    </Tag>
  )
}
